import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
/**
 * @fragment SaleItemVariantValueFragment
 * @since 1.0.0
 */
export const SaleItemVariantValueFragment = gql `
  fragment SaleItemVariantValueFragment on SaleItemVariantValue {
    id
    value
    field {
      ...FieldFragment
    }
  }

  ${FieldFragment}
`;
/**
 * @fragment SaleItemVariantFragment
 * @since 1.0.0
 */
export const SaleItemVariantFragment = gql `
  fragment SaleItemVariantFragment on SaleItemVariant {
    id
    sku
    price
    cost
    inventory
    active
    title
    createdAt
    updatedAt

    image {
      ...MediaFragment
    }

    item {
      id
      sku
      title
    }

    values {
      ...SaleItemVariantValueFragment
    }

    options {
      id
      price
      quantity
      required
      included
      locked
      proposed
      recommended
      item {
        id
        title
        infos
        sku
        price
        active
        deletedAt
        group {
          id
          title
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
        groups {
          id
          title
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
        image {
          ...SaleItemImageFragment
        }
      }
      relations {
        id
        type
        quantity
        relatedSaleItem {
          id
          title
          price
          sku
        }
      }
    }

    manufacturing {
      id
      item {
        id
        sku
        title
      }
      quantity
    }

    fieldValues {
      id
      value
      field {
        id
        name
        title
        infos
        visibility
        promote
        type
        group {
          id
          category
        }
      }
    }

    translations {
      id
      title

      language {
        ...LanguageFragment
      }
    }
  }

  ${SaleItemVariantValueFragment}
  ${MediaFragment}
  ${LanguageFragment}
  ${SaleItemImageFragment}
`;
